<script setup lang="ts">
import { useRouteAccess } from "@/composables/useRouteAccess";
import SetupPrompt from "@/components/SetupPrompt.vue";

const { shouldShowUpgradePrompt } = useRouteAccess();
</script>

<template>
  <SetupPrompt v-if="shouldShowUpgradePrompt" :requireStandardPlan="true" />
  <slot v-else />
</template>
